module.exports = __webpack_public_path__ + "assets/img/28fd-cu.svg";